import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * L'atelier d'un canvas se règle depuis lui, dans la modale des réglages
 * (cf. `SettingsModal`) : la page hors canvas n'a rien à proposer.
 */
export const Route = createFileRoute("/settings/sandbox")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/account" });
  },
});
